import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

// Add a resident (resident = null) or edit an existing one.
const ResidentDialog = ({ open, resident, onClose, onSave, saving }) => {
  const [name, setName] = useState("");
  const [specialty, setSpecialty] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setName(resident ? resident.name : "");
      setSpecialty(resident ? resident.specialty : "");
      setError("");
    }
  }, [open, resident]);

  const handleSave = () => {
    if (!name.trim()) {
      setError("Name is required.");
      return;
    }
    onSave({ name: name.trim(), specialty: specialty.trim() })
      .then(onClose)
      .catch((err) => setError(err?.data?.message || "Failed to save resident."));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{resident ? "Edit resident" : "Add resident"}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Ειδικευόμενος"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mt: "0.5rem", mb: "1rem" }}
        />
        <TextField
          fullWidth
          label="Τελική ειδικότητα"
          value={specialty}
          onChange={(e) => setSpecialty(e.target.value)}
        />
        {error && (
          <Typography color="error" sx={{ mt: "0.75rem" }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="secondary" onClick={handleSave} disabled={saving}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResidentDialog;
